import { connect } from "react-redux";

import MemberInvitation from "./MemberInvitation";

// Actions
import {
  inviteMember,
  inviteMemberBulk,
  deleteMemberInvitation,
  clearMemberInvited,
} from "../membersActions";
import { completeAppOnboardingStep } from "../../AppOnboarding/appOnboardingActions";

// Store props to map with current state
const mapStateToProps = (state) => ({
  selectedOrganization: state.organization.selectedOrganization,
  projectList: state.project.projectShortList,
  isLoading: state.member.isLoading,
  projectIsLoading: state.project.shortListIsLoading,
  inviteMemberLoading: state.member.inviteMemberLoading,
  memberInvited: state.member.memberInvited,
  appOnboardingSteps: state.appOnboarding?.steps,
});

// Actions prop to dispatch
const mapDispatchToProps = (dispatch) => ({
  inviteMember: (details) => dispatch(inviteMember({ ...details })),
  inviteMemberBulk: (details) => dispatch(inviteMemberBulk({ ...details })),
  deleteMemberInvitation: (details) =>
    dispatch(deleteMemberInvitation({ ...details })),
  clearMemberInvited: () => dispatch(clearMemberInvited()),
  completeAppOnboardingStep: (organizationId, stepId) =>
    dispatch(completeAppOnboardingStep(organizationId, stepId)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(MemberInvitation);
